function fileDownload($q, $http, FileSaver, Blob) {

  return function download(uri, filename) {
    return $http.get(uri, { responseType: 'arraybuffer' })
      .then( response => {
        let contentType = response.headers('Content-Type') || 'application/text';
        const data = response.data instanceof Array ? response.data : [response.data];

        if (contentType.indexOf(';') !== -1) {
          contentType = contentType.substring(0, contentType.indexOf(';'));
        }

        const blob = data instanceof Blob ? data : new Blob(data, {type: contentType});

        try {
          FileSaver.saveAs(blob, filename);
        } catch (err) {
          return $q.reject(err);
        }
      });
  };
}

fileDownload.$inject = ['$q', '$http', 'FileSaver', 'Blob'];
export default fileDownload;
